export { default } from "./SentryErrorBoundary"
